var runtime = require("../../../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"container":"_2S7U0","thumbnailRatioContainer":"_20aTx"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._2S7U0{position:relative;overflow:hidden}"+wrap+" ._20aTx{position:relative;padding-top:56.25%}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

